<template>
  <div>
    {{ $t('checkIn') }}: {{booking.night.first | date}}
    <br>

    {{ $t('checkOut') }}: {{booking.night.last | checkOut}}
    <br>
    {{ $t('nights') }}: {{ dayDiff(booking.night.first, booking.night.last) }}
    <br>
    {{ $t('room') }}: {{booking.room ? booking.room.name : ''}}
    <br>
    {{ $t('unit') }}: {{booking | unit}}
    <br>
    {{ $t('guests') }}: {{booking.numGuests.adults + booking.numGuests.children}}
    <span v-if="booking.referer">
      <br>
      {{ $t('referer') }}: {{booking.referer.channel}}
    </span>
    <br>
    {{ $t('date') }}: {{booking.created | date}}
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Booking',
    props: ['booking'],
    filters: {
      date: function(date){
        if(!date) return '';
        return moment(date).format('DD/MM/YYYY');
      },
      checkOut: function(date){
        if(!date) return '';
        return moment(date).add(1, 'days').format('DD/MM/YYYY');
      },
      unit: function(booking){
        if(!booking.unitId || !booking.room || booking.unitId > booking.room.qantity) return;
        let units = booking.room.units || [];
        return units[booking.unitId - 1] ? units[booking.unitId - 1].name : booking.unitId
      }
    },
    methods: {
      roomName: function(room){
        const property = this.$store.state.host.properties.find(p => p.rooms.find(r => r._id == room));
        return property ? property.rooms.find(r => r._id == room).name : '';
      },
      dayDiff: function(start, end){
        return moment(end).add(1, 'days').diff(moment(start), 'days');
      },
    }
  }
</script>

<i18n>
{
  "en": {
    "room": "Room type",
    "unit": "Unit",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "guests": "Number of Guests",
    "nights": "Nights",
    "date": "Date",
    "referer": "Referer"
  },
  "sl": {
    "room": "Tip sobe",
    "unit": "Enota",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "guests": "Število gostov",
    "nights": "Nočitve",
    "date": "Datum",
    "referer": "Kanal"
  }
}
</i18n>
